/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Home_Waiting_SinceInputs */



/**
* | output |
* | --- |
* | "invited {date}" |
*
* @param {Partner_Home_Waiting_SinceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_waiting_since = /** @type {((inputs: Partner_Home_Waiting_SinceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Waiting_SinceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`eingeladen am ${i?.date}`)
	return /** @type {LocalizedString} */ (`invited ${i?.date}`)
});